// extracted by mini-css-extract-plugin
export var layoutContainer = "_4f-0";
export var layoutContainerNoRounding = "_4f-6";
export var layoutContainerOpen = "_4f-5";
export var layoutContainerResizing = "_4f-1";
export var mainContent = "_4f-2";
export var resizeDivider = "_4f-3";
export var slidePanel = "_4f-4";